module.exports = __webpack_public_path__ + "static/media/like-black.252b2e67.svg";